import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TrustPaymentMethodPage } from './trust-payment-method.page';

const routes: Routes = [
  {
    path: '',
    component: TrustPaymentMethodPage,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class TrustPaymentMethodPageRoutingModule {}
